import type { InjectionKey } from 'vue';
import { provideLocal, injectLocal } from '@vueuse/core';

const STICKY_ATB_SLIDEOUT_CONTEXT_ENABLED: InjectionKey<{ isStickyAtbSlideoutContextEnabled: boolean }> = Symbol(
  'STICKY_ATB_SLIDEOUT_CONTEXT_ENABLED_REPOSITORY',
);

/**
 * @description Injects the STICKY_ATB_STATE_ENABLED token with a value of true.
 */
export function useStickyAtbSlideoutContextEnabledProvide() {
  provideLocal(STICKY_ATB_SLIDEOUT_CONTEXT_ENABLED, { isStickyAtbSlideoutContextEnabled: true });
}

/**
 * @description Retrieves whether the sticky ATB state is currently enabled in the nearest ancestor.
 * @returns  {object} { isStickyAtbSlideoutContextEnabled: boolean } True if sticky ATB state is enabled, false otherwise.
 */
export function useStickyAtbSlideoutContextEnabled() {
  return injectLocal(STICKY_ATB_SLIDEOUT_CONTEXT_ENABLED, () => ({ isStickyAtbSlideoutContextEnabled: false }), true);
}
